module.exports = __webpack_public_path__ + "static/media/front-section2-bg.181723c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/front-section2-bg.png
// module id = 698
// module chunks = 0